import React, { useState } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";

const steps = [
    {
        title: "Step 1: Post Your Job Openings",
        content: (
            <>
                <p className="font-weight-bold">
                    Reach Quality Candidates Through JobInfoNetwork
                </p>
                <p>
                    Use the "Post Job" feature to create detailed job postings that will
                    be visible to job seekers across the network.
                </p>
                <p>
                    Include comprehensive information about the position, required
                    qualifications, and your company culture to attract the right
                    candidates.
                </p>
            </>
        ),
    },
    {
        title: "Step 2: Review Resumes",
        content: (
            <>
                <p>
                    Browse through the resumes of qualified job seekers who are actively
                    looking for opportunities in your industry.
                </p>
                <p>
                    Use the search and filter features to find candidates that match your
                    specific requirements and job openings.
                </p>
                <p>
                    You can save interesting profiles for later review and reach out to
                    promising candidates directly through the messaging system.
                </p>
            </>
        ),
    },
    {
        title: "Step 3: Connect and Communicate",
        content: (
            <>
                <p>
                    Use the messaging feature to communicate directly with job seekers
                    who have applied to your postings or whose profiles interest you.
                </p>
                <p>
                    Remember to check your dashboard regularly for new applications and
                    messages from potential candidates.
                </p>
            </>
        ),
    },
];

export default function EmployerOnboardingModal({ show, onHide, onFinish }) {
    const [step, setStep] = useState(0);

    const handleNext = () => {
        if (step < steps.length - 1) setStep(step + 1);
        else {
            if (onFinish) onFinish(true);
            onHide();
            setStep(0); // reset for next open
        }
    };

    const handleBack = () => {
        if (step > 0) setStep(step - 1);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{steps[step].title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProgressBar now={((step + 1) / steps.length) * 100} className="mb-3" />
                {steps[step].content}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleBack} disabled={step === 0}>
                    Back
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    {step === steps.length - 1 ? "Finish" : "Next"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
